// src/components/ZoomableImage.js
import React, { useState } from 'react';
import './ZoomableImage.css'; // Add CSS to style the zoomable image

function ZoomableImage({ src, alt }) {
  const [scale, setScale] = useState(1);
  const zoomStep = 0.2;
  const minScale = 0.5;
  const maxScale = 5;

  const zoomIn = () => {
    setScale(prev => Math.min(prev + zoomStep, maxScale));
  };

  const zoomOut = () => {
    setScale(prev => Math.max(prev - zoomStep, minScale));
  };

  // Allow zooming with the touchpad/mouse wheel
  const handleWheel = (e) => {
    e.preventDefault();
    // Zoom in if scrolling up; zoom out if scrolling down.
    if (e.deltaY < 0) {
      zoomIn();
    } else if (e.deltaY > 0) {
      zoomOut();
    }
  };

  return (
    <div className="zoomable-image-container">
      <div className="zoom-controls">
        <button onClick={zoomOut} className="zoom-button">−</button>
        <button onClick={zoomIn} className="zoom-button">+</button>
      </div>
      <div 
        className="image-wrapper" 
        style={{ transform: `scale(${scale})` }}
        onWheel={handleWheel}
      >
        <img src={src} alt={alt} />
      </div>
    </div>
  );
}

export default ZoomableImage;
